import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { MessageService } from './message.service';
import { StoreLocationOverride } from '../models/storeLocationOverride';

@Injectable({ providedIn: 'root' })

export class StoreLocationOverrideService {

  private _ENDPOINT: string = '';

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,
    private messageService: MessageService, @Inject('BASE_URL') baseUrl) {
    this._ENDPOINT = baseUrl + 'api/storeLocationOverrides';
  }
 
  getAll(id: any): Observable<Array<StoreLocationOverride>> {
    const url = this._ENDPOINT + '/?brandId=' + id;
    return this.http.get<Array<StoreLocationOverride>>(url); 
  }

  getById(id: any): Observable<StoreLocationOverride> {
    const url = this._ENDPOINT + '/' + id;
    return this.http.get<StoreLocationOverride>(url);
  }

  /** POST: add a new storeLocationOverride to the server */
  add(storeLocationOverride: StoreLocationOverride): Observable<StoreLocationOverride> {
    return this.http.post<StoreLocationOverride>(this._ENDPOINT, storeLocationOverride, this.httpOptions).pipe(
      tap((newStoreLocationOverride: StoreLocationOverride) => this.log('added store location override w/ id=${newStoreLocationOverride.id}')),
      catchError(this.handleError<StoreLocationOverride>('add'))
    );
  }

  /** DELETE: delete the storeLocationOverride from the server */
  delete(id: number): Observable<StoreLocationOverride> { 
    const url = this._ENDPOINT + '/' + id;

    return this.http.delete<StoreLocationOverride>(url, this.httpOptions).pipe(
      tap(_ => this.log('deleted storeLocationOverride id=${id}')),
      catchError(this.handleError<StoreLocationOverride>('deleteStoreLocationOverride'))
    );
  }

  /** PUT: update the storeLocationOverride on the server */
  update(id: number, storeLocationOverride: StoreLocationOverride): Observable<any> {
    return this.http.put(this._ENDPOINT + "/" + id, storeLocationOverride, this.httpOptions).pipe(
      tap(_ => this.log('updated storeLocationOverride id=${storeLocationOverride.Id}')),
      catchError(this.handleError<any>('updateStoreLocationOverride'))
    );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a StoreLocationOverrideService message with the MessageService */
  private log(message: string) {
    this.messageService.add(`StoreLocationOverrideService: ${message}`);
  }
}
